import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { RegistrationService } from 'src/app/core/services/registration.service';
import { RegWorkflowMappingService } from 'src/app/core/services/reg-workflow-mapping.service';
import { NavigationRoute } from 'src/app/core/constants/constants';
import { RegWorkflowEnum } from 'src/app/core/dtos/enum';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { selectRegTestSession } from 'src/app/state/reg-data.selectors';
import { HotToastService } from '@ngneat/hot-toast';
import { BiometricConsentRequest, TestSessionForRegistrationDto } from 'src/app/core/dtos/dto';
import { Step } from 'src/app/core/dtos/step';
import { PageStepEnum, StepProgressService } from 'src/app/core/services/step-progress.service';

@Component({
  selector: 'app-biometric-consent',
  templateUrl: './biometric-consent.component.html',
  styleUrls: ['./biometric-consent.component.scss']
})
export class BiometricConsentComponent implements OnInit, OnDestroy {

  setConsentSubscription: Subscription;
  testSessionSubscription: Subscription;
  pagePath = NavigationRoute.REGISTRATION.proofOfIdentity;
  regWorkFlow: RegWorkflowEnum;
  steps: Step[];
  testSession$: Observable<TestSessionForRegistrationDto>;

  constructor(
    private registrationService: RegistrationService,
    private regWorkflowMappingService: RegWorkflowMappingService,
    private router: Router,
    private store: Store,
    private toastService: HotToastService,
    private stepProgressServiceService: StepProgressService,
  ) {
    this.steps = this.stepProgressServiceService.getSteps(PageStepEnum.ProofOfIdentity);
  }

  ngOnInit(): void {
    this.testSession$ = this.store.pipe(select(selectRegTestSession));
  }

  goNext(biometricConsentRequest: BiometricConsentRequest) {
    this.setConsentSubscription = this.registrationService.setBiometricConsent(biometricConsentRequest)
      .subscribe(
        () => this.redirectNextStep(),
        () => this.toastService.warning("Failed to save biometric consent.")
      );
  }

  redirectNextStep() {
    this.testSessionSubscription = this.testSession$
      .subscribe(testSession => {
        this.regWorkFlow = this.regWorkflowMappingService.getRegWorkFlow(testSession);
        const nextStep = this.regWorkflowMappingService.getNextStepNew(this.regWorkFlow, this.pagePath);
        this.router.navigate([nextStep]);
      });
  }

  ngOnDestroy() {
    this.setConsentSubscription?.unsubscribe();
    this.testSessionSubscription?.unsubscribe();
  }

}
